/** Async feature bundle for LazyMotion — loaded as a separate chunk after initial paint, not bundled into every route's main JS. */
export const loadMotionFeatures = () => import("framer-motion").then((mod) => mod.domAnimation);
